// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionEnvelope, ActionEnvelopeT } from '../tbs/action-envelope.js';
import { ActionLogEnvelope, ActionLogEnvelopeT } from '../tbs/action-log-envelope.js';
import { EnginePayload, unionToEnginePayload, unionListToEnginePayload } from '../tbs/engine-payload.js';
import { ErrorEnvelope, ErrorEnvelopeT } from '../tbs/error-envelope.js';
import { MapScriptFormDataEnvelope, MapScriptFormDataEnvelopeT } from '../tbs/map-script-form-data-envelope.js';
import { PlayerViewEnvelope, PlayerViewEnvelopeT } from '../tbs/player-view-envelope.js';
import { ReplayEnvelope, ReplayEnvelopeT } from '../tbs/replay-envelope.js';
import { StateEnvelope, StateEnvelopeT } from '../tbs/state-envelope.js';


export class EngineMessage implements flatbuffers.IUnpackableObject<EngineMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EngineMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEngineMessage(bb:flatbuffers.ByteBuffer, obj?:EngineMessage):EngineMessage {
  return (obj || new EngineMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEngineMessage(bb:flatbuffers.ByteBuffer, obj?:EngineMessage):EngineMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EngineMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

payloadType():EnginePayload {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : EnginePayload.NONE;
}

payload<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startEngineMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addPayloadType(builder:flatbuffers.Builder, payloadType:EnginePayload) {
  builder.addFieldInt8(0, payloadType, EnginePayload.NONE);
}

static addPayload(builder:flatbuffers.Builder, payloadOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, payloadOffset, 0);
}

static endEngineMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static finishEngineMessageBuffer(builder:flatbuffers.Builder, offset:flatbuffers.Offset) {
  builder.finish(offset);
}

static finishSizePrefixedEngineMessageBuffer(builder:flatbuffers.Builder, offset:flatbuffers.Offset) {
  builder.finish(offset, undefined, true);
}

static createEngineMessage(builder:flatbuffers.Builder, payloadType:EnginePayload, payloadOffset:flatbuffers.Offset):flatbuffers.Offset {
  EngineMessage.startEngineMessage(builder);
  EngineMessage.addPayloadType(builder, payloadType);
  EngineMessage.addPayload(builder, payloadOffset);
  return EngineMessage.endEngineMessage(builder);
}

unpack(): EngineMessageT {
  return new EngineMessageT(
    this.payloadType(),
    (() => {
      const temp = unionToEnginePayload(this.payloadType(), this.payload.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: EngineMessageT): void {
  _o.payloadType = this.payloadType();
  _o.payload = (() => {
      const temp = unionToEnginePayload(this.payloadType(), this.payload.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}
}

export class EngineMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public payloadType: EnginePayload = EnginePayload.NONE,
  public payload: ActionEnvelopeT|ActionLogEnvelopeT|ErrorEnvelopeT|MapScriptFormDataEnvelopeT|PlayerViewEnvelopeT|ReplayEnvelopeT|StateEnvelopeT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const payload = builder.createObjectOffset(this.payload);

  return EngineMessage.createEngineMessage(builder,
    this.payloadType,
    payload
  );
}
}
